import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import LogoSvg from "../../common/assets/images/logo1.svg";
import { LockClosedIcon } from "@heroicons/react/24/outline";
import { UserIcon } from "lucide-react";
import { Link } from "react-router-dom";
import { login } from "../../services/AuthService";
import { localStorageSetItem } from "../../common/localStorage";
import { toast } from "react-toastify";
import DeviceManagementModal from "../common/DeviceManagementModal";

const LoginPage = () => {
  const navigate = useNavigate();
  const [showDeviceModal, setShowDeviceModal] = useState(false);

  const [formData, setFormData] = useState({
    email: "",
    password: "",
    rememberMe: false,
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.email || !formData.password) {
      toast.error("Vui lòng nhập đầy đủ email và mật khẩu");
      return;
    }

    setLoading(true);
    try {
      const response = await login({
        email: formData.email,
        password: formData.password,
      });
      if (response?.token) {
        // Lưu token và thông tin user vào localStorage
        localStorageSetItem("jwt", {
          token: response.token,
        });
        localStorageSetItem("user", {
          fullName: response.fullName,
          email: response.email,
          identifier: response.identifier,
          premium: response.premium,
        });

        toast.success(response.message || "Đăng nhập thành công!");

        // Redirect về trang chủ
        navigate("/");
      } else {
        toast.error(response?.message || "Đăng nhập thất bại");
      }
    } catch (error) {
      const errorCode = error?.response?.data?.code;
      const message = error?.response?.data?.message || error.message;

      if (errorCode === "MAX_DEVICES_REACHED") {
        setShowDeviceModal(true);
      } else {
        toast.error(message);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-200px)] bg-[#f9dfe8]">
      <div className="max-w-[650px] mx-auto px-4 py-12 md:py-16">
        <div className="bg-[#f6d2df] bg-opacity-40 rounded-[8px] shadow-[0_12px_30px_rgba(219,59,109,0.15)] border border-[#efb8c8] p-6 md:p-10">
          {/* Title */}
          <div className="flex justify-center items-center">
            <img src={LogoSvg} alt="PIMAX" className="w-14 h-14" />
            <h1 className="text-[#db3b6d] text-[36px] font-extrabold tracking-wide ml-5">
              ĐĂNG NHẬP
            </h1>
          </div>

          {/* Form */}
          <form className="mt-8 mx-auto max-w-[360px]" onSubmit={handleSubmit}>
            {/* Username */}
            <div className="mb-4">
              <div className="relative">
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="EMAIL ĐĂNG NHẬP"
                  className="w-full h-11 md:h-12 rounded-[15px] border border-[#e5a7b7] bg-white/70 pl-4 pr-12 text-[#4b4b4b] placeholder-[#4b4b4b] focus:outline-none focus:ring-2 focus:ring-[#db3b6d]"
                  disabled={loading}
                />
                <UserIcon className="w-5 h-5 text-[#db3b6d] absolute right-3 top-1/2 -translate-y-1/2" />
              </div>
            </div>

            {/* Password */}
            <div className="mb-2">
              <div className="relative">
                <input
                  type="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="MẬT KHẨU"
                  className="w-full h-11 md:h-12 rounded-[15px] border border-[#e5a7b7] bg-white/70 pl-4 pr-12 text-[#4b4b4b] placeholder-[#4b4b4b] focus:outline-none focus:ring-2 focus:ring-[#db3b6d]"
                  disabled={loading}
                />
                <LockClosedIcon className="w-5 h-5 text-[#db3b6d] absolute right-3 top-1/2 -translate-y-1/2" />
              </div>
            </div>

            {/* Forgot & remember */}
            <div className="flex items-center justify-between text-sm mt-2 mb-5">
              <Link to="#" className="text-[#db3b6d]">
                QUÊN MẬT KHẨU?
              </Link>
              <label className="inline-flex items-center gap-2 text-[#4b4b4b]">
                <input
                  type="checkbox"
                  name="rememberMe"
                  checked={formData.rememberMe}
                  onChange={handleChange}
                  className="accent-[#db3b6d] w-4 h-4"
                  disabled={loading}
                />
                <span>DUY TRÌ ĐĂNG NHẬP</span>
              </label>
            </div>

            {/* Submit */}
            <button
              type="submit"
              className="w-full h-12 bg-[#db3b6d] hover:bg-[#c63262] text-white font-semibold rounded-[15px] shadow-md disabled:opacity-50 disabled:cursor-not-allowed"
              disabled={loading}
            >
              {loading ? "ĐANG ĐĂNG NHẬP..." : "ĐĂNG NHẬP"}
            </button>

            <div className="text-center mt-5 text-[#4b4b4b]">
              Bạn chưa có tài khoản?{" "}
              <Link to="/register" className="text-[#db3b6d] font-semibold">
                ĐĂNG KÍ
              </Link>
            </div>
          </form>
        </div>
      </div>
      {/* Device Management Modal */}
      <DeviceManagementModal
        isOpen={showDeviceModal}
        onClose={() => setShowDeviceModal(false)}
      />
    </div>
  );
};

export default LoginPage;
